import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Icon from '../../Icons'
import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class BuildingCodeField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    this.props.setFormFieldValue(formType, fieldName, initialValue)
    this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  valueChange(e) {
    e.preventDefault()
    const { formType, fieldName } = this.props
    this.props.setFormFieldValue(formType, fieldName, e.target.value)
    this.props.validateFormField(formType, fieldName, this.isValid(e.target.value))
  }

  isValid(val) {
    return val.toString().length > 0
  }

  render() {
    const { form, formType, fieldName, label, placeholder, additionalClass, isDisabled } =
      this.props
    return (
      <div className="field field-icon">
        {label && (
          <label htmlFor={fieldName} className="label">
            {label}
          </label>
        )}
        <div className="control">
          <Icon icon="building" />
          <input
            type="text"
            maxLength={16}
            name={fieldName}
            className={`input ${additionalClass}`}
            value={form[formType][fieldName].value}
            onChange={this.valueChange}
            id={fieldName}
            placeholder={placeholder}
            disabled={isDisabled}
          />
        </div>
      </div>
    )
  }
}

BuildingCodeField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  isDisabled: PropTypes.bool.isRequired,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(BuildingCodeField)
